export {getChartsInsightsData} from './getChartsInsightsData';
